import { call, put } from '@redux-saga/core/effects';
import { api, apiErrorHandler, notify } from 'services';
import {
  UpdateBuildingActions as Actions,
  UpdateBuildingRequestAction as RequestAction,
} from 'store/ducks/buildings';

export function* updateBuildingRequest(action: any) {
  const { id, putData, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.put, `buildings/${id}`, putData);
    onSuccess && onSuccess();
    notify('success', 'Prédio atualizado com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
